/* global CryptoJS */
import React, { useEffect, useState } from 'react';
import { useProfileDataContext } from '../HomePage/ProfileContext';
import { Modal, Button, Spinner } from "react-bootstrap";
import { ooredooDCBUnsubscribeUser } from '../../Utilities/controller';
import { toast } from 'react-toastify'

const UnSubscribepopup = (props) => {

    const { liteProfile, userPremiumDetails } = useProfileDataContext();
    const selectedItem = props?.selectedItem || null;
    const [isPlanChange, setIsPlanChange] = useState(false);

    // Function to close the popup
    const closePopup = () => {
        setIsPlanChange(false);
        props.setSelecetedItem(null);
        props.setIsPopupVisible(false);
    };

    // Function to unsubscribe the user
    const handleUnsubscribe = async(user_id) => {
        try {
            const userUnSubscribe = await ooredooDCBUnsubscribeUser(
                {
                    user_id: user_id || userPremiumDetails?.userID || liteProfile?.item?.user_id ,
                    gamerjiName: liteProfile?.item?.gamerjiName || "",
                    userObjectID: liteProfile?.item?._id || "",
                    SubscriptionId: getMatchedPackId(userPremiumDetails),
                    planCode: userPremiumDetails?.planDetails?.planCode || 0,
                    companyID: userPremiumDetails?.planDetails?.companyID || "",
                    countryID: userPremiumDetails?.planDetails?.countryID || ""
                }
            );
            // console.log("userUnSubscribe----------->",userUnSubscribe);

            if(userUnSubscribe?.data?.success) {
                toast.success("User UnSubscription Successfully");
                setTimeout(() => {
                    window.location.href = "/home";
                }, 1500);
            } else {
                toast.error("Error at unsubscribing the user")
            }
        } catch (error) {
            console.error("error at handleUnsubscribe->",error);
        }
    }

    const getMatchedPackId = (subscription) => {
        // Function to calculate difference in days
        function calculateDateDifference(startDate, endDate) {
            // Calculate difference in milliseconds
            const diffInMilliseconds = new Date(endDate) - new Date(startDate);

            // Convert to days (milliseconds to days)
            return diffInMilliseconds / (1000 * 60 * 60 * 24);
        }

        // Extract the days difference between subscription start and end date
        const differenceInDays = calculateDateDifference(subscription.startDate, subscription.subscriptionEndDate);

        // Find the pack that matches the timeDuration
        const matchedPack = subscription.planDetails.packs.find(pack => parseInt(pack.timeDuration) === differenceInDays);

        // Return the _id of the matched pack
        return matchedPack ? matchedPack._id : null;
    }

    // Function to format date in a user-friendly way
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-US', options);
    };

    useEffect(()=>{
        if( selectedItem?._id?.length > 0 && userPremiumDetails?.planDetails?._id) {
            setIsPlanChange(true);
        }
    },[selectedItem,userPremiumDetails]);

    // console.log("userPremiumDetails -------------->",isPlanChange);

    return (
        <Modal show={props.isPopupVisible} centered backdrop="static" keyboard={false} onHide={closePopup} >
            <Modal.Body>
                <div>
                    {
                        (userPremiumDetails && userPremiumDetails.isPremium ) ?
                            (
                                <div>
                                    <h3>Are you sure you want to {isPlanChange ? ' Change the Plan' :' unsubscribe'}?</h3>
                                    <p>Your current subscription details:</p>
                                    <ul>
                                        <li><strong>Start Date: </strong>{formatDate(userPremiumDetails.startDate)}</li>
                                        <li><strong>Subscription End Date: </strong>{formatDate(userPremiumDetails.subscriptionEndDate)}</li>
                                    </ul>
                                    {
                                        isPlanChange ?
                                        <>
                                            <p><strong>Are you sure you want to proceed with new subscription?</strong></p>
                                        </>
                                        :
                                        <>
                                            <p>If you confirm, you will lose access to premium features after the current subscription period ends on <strong>{formatDate(userPremiumDetails.subscriptionEndDate)}</strong>.</p>
                                            <p><strong>Are you sure you want to proceed with canceling your subscription?</strong></p>
                                        </>
                                    }
                                </div>
                            ) :
                            (
                                <div style={{ padding: "20px" }}>
                                    <Button variant="primary" disabled>
                                        <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                        Loading...
                                    </Button>
                                </div>
                            )
                    }
                    <div style={{display:"flex",justifyContent:"center",gap:"40px"}}>
                        <button onClick={()=> isPlanChange ? props.handleBuySecondPlan(true) : handleUnsubscribe(userPremiumDetails.userID)} className='btn btn-dark ml-2'>Confirm</button>
                        <button onClick={closePopup} className="btn btn-danger ml-1">Cancel</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default UnSubscribepopup;
